<tui-root>
  <router-outlet />

  <fin-selected-instruments-summary-popup-host />
</tui-root>
